const data_tbu_lk = [
    { umur: 0, sd_3: 44.2, sd_2: 46.1, med: 49.9, sd2: 53.7, sd3: 55.6 },
    { umur: 1, sd_3: 48.9, sd_2: 50.8, med: 54.7, sd2: 58.6, sd3: 60.6 },
    { umur: 2, sd_3: 52.4, sd_2: 54.4, med: 58.4, sd2: 62.4, sd3: 64.4 },
    { umur: 3, sd_3: 55.3, sd_2: 57.3, med: 61.4, sd2: 65.5, sd3: 67.6 },
    { umur: 4, sd_3: 57.6, sd_2: 59.7, med: 63.9, sd2: 68.0, sd3: 70.1 },
    { umur: 5, sd_3: 59.6, sd_2: 61.7, med: 65.9, sd2: 70.1, sd3: 72.2 },
    { umur: 6, sd_3: 61.2, sd_2: 63.3, med: 67.6, sd2: 71.9, sd3: 74.0 },
    { umur: 7, sd_3: 62.7, sd_2: 64.8, med: 69.2, sd2: 73.5, sd3: 75.7 },
    { umur: 8, sd_3: 64.0, sd_2: 66.2, med: 70.6, sd2: 75.0, sd3: 77.2 },
    { umur: 9, sd_3: 65.2, sd_2: 67.5, med: 72.0, sd2: 76.5, sd3: 78.7 },
    { umur: 10, sd_3: 66.4, sd_2: 68.7, med: 73.3, sd2: 77.9, sd3: 80.1 },
    { umur: 11, sd_3: 67.6, sd_2: 69.9, med: 74.5, sd2: 79.2, sd3: 81.5 },
    { umur: 12, sd_3: 68.6, sd_2: 71.0, med: 75.7, sd2: 80.5, sd3: 82.9 },
    { umur: 13, sd_3: 69.6, sd_2: 72.1, med: 76.9, sd2: 81.8, sd3: 84.2 },
    { umur: 14, sd_3: 70.6, sd_2: 73.1, med: 78.0, sd2: 83.0, sd3: 85.5 },
    { umur: 15, sd_3: 71.6, sd_2: 74.1, med: 79.1, sd2: 84.2, sd3: 86.7 },
    { umur: 16, sd_3: 72.5, sd_2: 75.0, med: 80.2, sd2: 85.4, sd3: 88.0 },
    { umur: 17, sd_3: 73.3, sd_2: 76.0, med: 81.2, sd2: 86.5, sd3: 89.2 },
    { umur: 18, sd_3: 74.2, sd_2: 76.9, med: 82.3, sd2: 87.7, sd3: 90.4 },
    { umur: 19, sd_3: 75.0, sd_2: 77.7, med: 83.2, sd2: 88.8, sd3: 91.5 },
    { umur: 20, sd_3: 75.8, sd_2: 78.6, med: 84.2, sd2: 89.8, sd3: 92.6 },
    { umur: 21, sd_3: 76.5, sd_2: 79.4, med: 85.1, sd2: 90.9, sd3: 93.8 },
    { umur: 22, sd_3: 77.2, sd_2: 80.2, med: 86.0, sd2: 91.9, sd3: 94.9 },
    { umur: 23, sd_3: 78.0, sd_2: 81.0, med: 86.9, sd2: 92.9, sd3: 95.9 },
    { umur: 24, sd_3: 78.7, sd_2: 81.7, med: 87.8, sd2: 93.9, sd3: 97.0 },
    { umur: 24, sd_3: 78.0, sd_2: 81.0,med: 87.1,sd2: 93.2, sd3: 96.3 },
    { umur: 25, sd_3: 78.6, sd_2: 81.7,med: 88.0,sd2: 94.2, sd3: 97.3 },
    { umur: 26, sd_3: 79.3, sd_2: 82.5,med: 88.8,sd2: 95.2, sd3: 98.3 },
    { umur: 27, sd_3: 79.9, sd_2: 83.1,med: 89.6,sd2: 96.1, sd3: 99.3 },
    { umur: 28, sd_3: 80.5, sd_2: 83.8,med: 90.4,sd2: 97.0, sd3: 100.3 },
    { umur: 29, sd_3: 81.1, sd_2: 84.5,med: 91.2,sd2: 97.9, sd3: 101.2 },
    { umur: 30, sd_3: 81.7, sd_2: 85.1,med: 91.9,sd2: 98.7, sd3: 102.1 },
    { umur: 31, sd_3: 82.3, sd_2: 85.7,med: 92.7,sd2: 99.6, sd3: 103.0 },
    { umur: 32, sd_3: 82.8, sd_2: 86.4,med: 93.4,sd2: 100.4, sd3: 103.9 },
    { umur: 33, sd_3: 83.4, sd_2: 86.9,med: 94.1,sd2: 101.2, sd3: 104.8 },
    { umur: 34, sd_3: 83.9, sd_2: 87.5,med: 94.8,sd2: 102.0, sd3: 105.6 },
    { umur: 35, sd_3: 84.4, sd_2: 88.1,med: 95.4,sd2: 102.7, sd3: 106.4 },
    { umur: 36, sd_3: 85.0, sd_2: 88.7,med: 96.1,sd2: 103.5, sd3: 107.2 },
    { umur: 37, sd_3: 85.5, sd_2: 89.2,med: 96.7, sd2: 104.2, sd3: 108.0 },
    { umur: 38, sd_3: 86.0, sd_2: 89.8,med: 97.4, sd2: 105.0, sd3: 108.8 },
    { umur: 39, sd_3: 86.5, sd_2: 90.3,med: 98.0, sd2: 105.7, sd3: 109.5 },
    { umur: 40, sd_3: 87.0, sd_2: 90.9,med: 98.6, sd2: 106.4, sd3: 110.3 },
    { umur: 41, sd_3: 87.5, sd_2: 91.4,med: 99.2, sd2: 107.1, sd3: 111.0 },
    { umur: 42, sd_3: 88.0, sd_2: 91.9,med: 99.9, sd2: 107.8, sd3: 111.7 },
    { umur: 43, sd_3: 88.4, sd_2: 92.4,med: 100.4, sd2: 108.5, sd3: 112.5 },
    { umur: 44, sd_3: 88.9, sd_2: 93.0,med: 101.0, sd2: 109.1, sd3: 113.2 },
    { umur: 45, sd_3: 89.4, sd_2: 93.5,med: 101.6, sd2: 109.8, sd3: 113.9 },
    { umur: 46, sd_3: 89.8, sd_2: 94.0,med: 102.2, sd2: 110.4, sd3: 114.6 },
    { umur: 47, sd_3: 90.3, sd_2: 94.4,med: 102.8, sd2: 111.1, sd3: 115.2 },
    { umur: 48, sd_3: 90.7, sd_2: 94.9,med: 103.3, sd2: 111.7, sd3: 115.9 },
    { umur: 49, sd_3: 91.2, sd_2: 95.4,med: 103.9, sd2: 112.4, sd3: 116.6 },
    { umur: 50, sd_3: 91.6, sd_2: 95.9, med: 104.4, sd2: 113.0, sd3: 117.3 },
    { umur: 51, sd_3: 92.1, sd_2: 96.4, med: 105.0, sd2: 113.6, sd3: 117.9 },
    { umur: 52, sd_3: 92.5, sd_2: 96.9, med: 105.6, sd2: 114.2, sd3: 118.6 },
    { umur: 53, sd_3: 93.0, sd_2: 97.4, med: 106.1, sd2: 114.9, sd3: 119.2 },
    { umur: 54, sd_3: 93.4, sd_2: 97.8, med: 106.7, sd2: 115.5, sd3: 119.9 },
    { umur: 55, sd_3: 93.9, sd_2: 98.3, med: 107.2, sd2: 116.1, sd3: 120.6 },
    { umur: 56, sd_3: 94.3, sd_2: 98.8, med: 107.8, sd2: 116.7, sd3: 121.2 },
    { umur: 57, sd_3: 94.7, sd_2: 99.3, med: 108.3, sd2: 117.4, sd3: 121.9 },
    { umur: 58, sd_3: 95.2, sd_2: 99.7, med: 108.9, sd2: 118.0, sd3: 122.6 },
    { umur: 59, sd_3: 95.6, sd_2: 100.2, med: 109.4, sd2: 118.6, sd3: 123.2 },
    { umur: 60, sd_3: 96.1, sd_2: 100.7, med: 110.0, sd2: 119.2, sd3: 123.9 }
  ];

  export default data_tbu_lk;